// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #region Button */

.xR6SxM6JOYE- {
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	width: -moz-fit-content;
	width: fit-content;
	padding: var(--space-smaller) var(--space-base);
	border: 1px solid var(--button-border);
	border-radius: var(--radius-base);
	background-color: var(--button-surface);
	color: var(--button-text);
	font-weight: var(--font-weight-base);
	font-family: var(--font-family-body);
	text-align: center;
	-webkit-text-decoration: none;
	text-decoration: none;
	text-wrap: nowrap;
	line-height: 0;
	cursor: pointer;
	transition: all 0.2s ease;
}

.xR6SxM6JOYE-:hover {
	border-color: var(--button-border-hover);
	background-color: var(--button-surface-hover);
	color: var(--button-text-hover);
}

.xR6SxM6JOYE-:active {
	border-color: var(--button-border-active);
	background-color: var(--button-surface-active);
	color: var(--button-text-active);
}

.xR6SxM6JOYE-.NCs-BISj1XU-:not(:disabled) {
	background-image: linear-gradient(
		135deg,
		rgba(0, 0, 0, 0.1) 0%,
		rgba(0, 0, 0, 0.1) 25%,
		transparent 25%,
		transparent 50%,
		rgba(0, 0, 0, 0.1) 50%,
		rgba(0, 0, 0, 0.1) 75%,
		transparent 75%,
		transparent 100%
	);
	background-size: var(--space-larger) var(--space-larger);
	animation-duration: var(--timing-loading-slow);
	animation-timing-function: linear;
	animation-iteration-count: infinite;
	animation-name: M0LU-Rdq-MA-;
	cursor: not-allowed;
	pointer-events: none;
}

.xR6SxM6JOYE-:disabled {
	border-color: var(--button-border-disabled);
	background-color: var(--button-surface-disabled);
	color: var(--button-text-disabled);
	cursor: not-allowed;
}

.-Ibb742Q6ck- {
	justify-content: start;
}

/* #endregion */

/* #region variants */

.TrzCxs3OEpM- {
	--button-surface: var(--color-surface-interactive-action-primary-base);
	--button-surface-hover: var(--color-surface-interactive-action-primary-hover);
	--button-surface-active: var(
		--color-surface-interactive-action-primary-active
	);
	--button-surface-disabled: var(
		--color-surface-interactive-action-primary-disabled
	);

	--button-text: var(--color-text-interactive-action-primary-base);
	--button-text-hover: var(--color-text-interactive-action-primary-hover);
	--button-text-active: var(--color-text-interactive-action-primary-active);
	--button-text-disabled: var(--color-text-interactive-action-primary-disabled);

	--button-border: var(--color-border-interactive-action-primary-base);
	--button-border-hover: var(--color-border-interactive-action-primary-hover);
	--button-border-active: var(--color-border-interactive-action-primary-active);
	--button-border-disabled: var(
		--color-border-interactive-action-primary-disabled
	);
}

.QaWL8FLJ5Aw- {
	--button-surface: var(--color-surface-interactive-action-secondary-base);
	--button-surface-hover: var(
		--color-surface-interactive-action-secondary-hover
	);
	--button-surface-active: var(
		--color-surface-interactive-action-secondary-active
	);
	--button-surface-disabled: var(
		--color-surface-interactive-action-prsecondaryimary-disabled
	);

	--button-text: var(--color-text-interactive-action-secondary-base);
	--button-text-hover: var(--color-text-interactive-action-secondary-hover);
	--button-text-active: var(--color-text-interactive-action-secondary-active);
	--button-text-disabled: var(
		--color-text-interactive-action-secondary-disabled
	);

	--button-border: var(--color-border-interactive-action-secondary-base);
	--button-border-hover: var(--color-border-interactive-action-secondary-hover);
	--button-border-active: var(
		--color-border-interactive-action-secondary-active
	);
	--button-border-disabled: var(
		--color-border-interactive-action-secondary-disabled
	);
}

.MhDYVRl8PUc- {
	--button-surface: var(--color-surface-interactive-action-tertiary-base);
	--button-surface-hover: var(
		--color-surface-interactive-action-tertiary-hover
	);
	--button-surface-active: var(
		--color-surface-interactive-action-tertiary-active
	);
	--button-surface-disabled: var(
		--color-surface-interactive-action-tertiary-disabled
	);

	--button-text: var(--color-text-interactive-action-tertiary-base);
	--button-text-hover: var(--color-text-interactive-action-tertiary-hover);
	--button-text-active: var(--color-text-interactive-action-tertiary-active);
	--button-text-disabled: var(
		--color-text-interactive-action-tertiary-disabled
	);

	--button-border: var(--color-border-interactive-action-tertiary-base);
	--button-border-hover: var(--color-border-interactive-action-tertiary-hover);
	--button-border-active: var(
		--color-border-interactive-action-tertiary-active
	);
	--button-border-disabled: var(
		--color-border-interactive-action-tertiary-disabled
	);
}

/* #endregion */

/* #region intents */

.v-Wis6ruH-8- {
	/* Base  for action buttons */
}

.kH2lHqHWQrI- {
	/* Base for destruction buttons */
}

.kH2lHqHWQrI-.TrzCxs3OEpM- {
	--button-surface: var(--color-surface-interactive-destruction-primary-base);
	--button-surface-hover: var(
		--color-surface-interactive-destruction-primary-hover
	);
	--button-surface-active: var(
		--color-surface-interactive-destruction-primary-active
	);
	--button-surface-disabled: var(
		--color-surface-interactive-destruction-primary-disabled
	);

	--button-text: var(--color-text-interactive-destruction-primary-base);
	--button-text-hover: var(--color-text-interactive-destruction-primary-hover);
	--button-text-active: var(
		--color-text-interactive-destruction-primary-active
	);
	--button-text-disabled: var(
		--color-text-interactive-destruction-primary-disabled
	);

	--button-border: var(--color-border-interactive-destruction-primary-base);
	--button-border-hover: var(
		--color-border-interactive-destruction-primary-hover
	);
	--button-border-active: var(
		--color-border-interactive-destruction-primary-active
	);
	--button-border-disabled: var(
		--color-border-interactive-destruction-primary-disabled
	);
}

.kH2lHqHWQrI-.QaWL8FLJ5Aw- {
	--button-surface: var(--color-surface-interactive-destruction-secondary-base);
	--button-surface-hover: var(
		--color-surface-interactive-destruction-secondary-hover
	);
	--button-surface-active: var(
		--color-surface-interactive-destruction-secondary-active
	);
	--button-surface-disabled: var(
		--color-surface-interactive-destruction-secondary-disabled
	);

	--button-text: var(--color-text-interactive-destruction-secondary-base);
	--button-text-hover: var(
		--color-text-interactive-destruction-secondary-hover
	);
	--button-text-active: var(
		--color-text-interactive-destruction-secondary-active
	);
	--button-text-disabled: var(
		--color-text-interactive-destruction-secondary-disabled
	);

	--button-border: var(--color-border-interactive-destruction-secondary-base);
	--button-border-hover: var(
		--color-border-interactive-destruction-secondary-hover
	);
	--button-border-active: var(
		--color-border-interactive-destruction-secondary-active
	);
	--button-border-disabled: var(
		--color-border-interactive-destruction-secondary-disabled
	);
}

.kH2lHqHWQrI-.MhDYVRl8PUc- {
	--button-surface: var(--color-surface-interactive-destruction-tertiary-base);
	--button-surface-hover: var(
		--color-surface-interactive-destruction-tertiary-hover
	);
	--button-surface-active: var(
		--color-surface-interactive-destruction-tertiary-active
	);
	--button-surface-disabled: var(
		--color-surface-interactive-destruction-tertiary-disabled
	);

	--button-text: var(--color-text-interactive-destruction-tertiary-base);
	--button-text-hover: var(--color-text-interactive-destruction-tertiary-hover);
	--button-text-active: var(
		--color-text-interactive-destruction-tertiary-active
	);
	--button-text-disabled: var(
		--color-text-interactive-destruction-tertiary-disabled
	);

	--button-border: var(--color-border-interactive-destruction-tertiary-base);
	--button-border-hover: var(
		--color-border-interactive-destruction-tertiary-hover
	);
	--button-border-active: var(
		--color-border-interactive-destruction-tertiary-active
	);
	--button-border-disabled: var(
		--color-border-interactive-destruction-tertiary-disabled
	);
}

/* #endregion */

/* #region sizes */

.lPPuBfTJl5k- {
	height: var(--element-small);
	padding: var(--space-smaller) var(--space-small);
	font-size: var(--font-size-smallest);
}

.VyMJpVxCrxI- {
	height: var(--element-base);
	font-size: var(--font-size-small);
}

/* #endregion */

/* other */

.yBId-F-geAA- {
	width: 100%;
}

@keyframes M0LU-Rdq-MA- {
	0% {
		background-position: 0 0;
	}

	100% {
		background-position: var(--space-larger) var(--space-larger);
	}
}

.gWgLCEdx90Q- {
	width: calc(var(--space-small) * 1.5);
	height: calc(var(--space-small) * 1.5);
}

.NukXJ1ku9MQ- {
	width: var(--space-base);
	height: var(--space-base);
}

.D2y5sdKc6Hs- {
	width: calc(var(--space-base) * 1.25);
	height: calc(var(--space-base) * 1.25);
}

.EJ0Npu8swS8- {
	width: 100%;
	border: 1px solid var(--color-border);
	border-radius: var(--radius-base);
	background-color: var(--color-surface-primary);
}

.EJ0Npu8swS8-[data-open] .CJjRz-TW4r4- svg {
			transform: rotate(180deg);
		}

:is(.EJ0Npu8swS8-[data-open] .CJjRz-TW4r4-) svg {
			transform: rotate(180deg);
		}

.CJjRz-TW4r4- {
	width: 100%;
	min-height: var(--element-base);
	padding: var(--space-small) var(--space-base);
	border: none;
	border-radius: var(--radius-base);
	background-color: var(--color-surface-primary);
}

.CJjRz-TW4r4- svg {
		flex-shrink: 0;
		color: var(--color-text-tertiary);
		transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	}

.CJjRz-TW4r4-:hover {
	min-height: var(--element-base);
	background-color: var(--color-surface-interactive-action-tertiary-active);
	cursor: pointer;
}

.-NZesrNGdMg- {
	padding: var(--accordion-panel-padding);
}

.Y-38p-yYvkA- {
	--accordion-panel-padding: 0;
}

.ynbo7clC9nY- {
	--accordion-panel-padding: var(--space-base);
}

.V8ZCH4DJl54- {
	padding: var(--spacing);
	border-width: 1px;
	border-style: solid;
	border-radius: var(--radius-base);
	border-color: var(--border-color);
	background-color: var(--color-surface-primary);
}

.UFdyLFofW7A- {
	--spacing: var(--space-large);
}

.Xn-MPG-KQoE- {
	--spacing: var(--space-base);
}

._7SG16IZ9dDI- {
	--spacing: var(--space-small);
}

.L1bJQuvLkl8- {
	--spacing: 0;
}

.u17T1FOCIUQ- {
	--border-color: var(--color-border-primary);
}

._6pB1Tcbnvp4- {
	--border-color: transparent;
}

.kWv7qiYlz48- {
	--border-color: var(--palette-green-70);
}

.nGNDuV2zBXI- {
	--border-color: var(--palette-orange-70);
}

.zbvTuS5uibw- {
	--border-color: var(--palette-red-70);
}

/* setting base text */
._0ima0sD4M-o- {
	margin: 0px;
	overflow: var(--text-overflow-hidden);
	color: var(--text-color);
	font-weight: var(--text-font-weight);
	font-size: var(--text-font-size);
	line-height: var(--text-line-height);
	font-family: var(--font-family-body);
	letter-spacing: var(--font-letter-spacing);
	text-align: var(--text-align);
	text-overflow: var(--text-overflow-ellipsis);
	white-space: var(--text-white-space);
	word-break: var(--text-word-break);
}
/* prominence styles */
.QQ3Dge26-a8- {
	--text-color: var(--color-text-primary);
}
.QfA-XyVS1U0- {
	--text-color: var(--color-text-secondary);
}
.DfNfnH2JAfk- {
	--text-color: var(--color-text-tertiary);
}
/* variants */
.o-QuIx39eRI- {
	--text-font-size: var(--font-size-small);
}
.e7L25fWiQDk- {
	--text-font-size: var(--font-size-smallest);
}
/* align styles */
._8EFOxhgOzbA- {
	display: block;
	--text-align: start;
}
.PEQQNIhwx7w- {
	display: block;
	--text-align: center;
}
.Z9E9xYSp3X4- {
	display: block;
	--text-align: end;
}
/* font weight */
.ftHpA4j7-Mc- {
	--text-font-weight: var(--font-weight-base);
}
.BP6qSj0jiQA- {
	--text-font-weight: var(--font-weight-bold);
}
/* line height */
.jCgA1vmWNCM- {
	--text-line-height: var(--font-line-height-base);
}
.xYqF6hAsEYY- {
	--text-line-height: var(--font-line-height-none);
}
/* formatting options */
.fpMmxsNRc68- {
	display: block;
	--text-white-space: nowrap;
	--text-overflow-hidden: hidden;
	--text-overflow-ellipsis: ellipsis;
}
.h4KhTBuOV-M- {
	--text-white-space: nowrap;
}
.EwzHK14Sxeg- {
	--text-word-break: break-all;
}
/* accent colours */
._9fnywQ6dkZ4- {
	/* placehoder */
}
.MibWHGrARRY- {
	--text-color: var(--palette-green-70);
}
.zrR5yh9ZQnY- {
	--text-color: var(--palette-red-70);
}
.JFZM0Zl-PEM- {
	--text-color: var(--palette-orange-70);
}
.snFkDfEXyyI- {
	--text-color: var(--palette-green-70);
}

.HTLeNI1dHkw- {
	width: 100%;
	max-width: 100%;
	overflow-y: auto;
	border: solid var(--space-minuscule) var(--color-border);
	border-radius: var(--radius-base);
}

.RSD-fmW5tBs- {
	width: 100%;
	max-width: 100%;
	border-spacing: 0;
	text-align: left;
	table-layout: fixed;
}

._1rjFYQERgMM- {
	text-align: left;
}

.c7Tce3P-ZPE- {
	padding: var(--space-small);
	border: none;
	background: none;
	text-align: left;
}

.c7Tce3P-ZPE-._804fMFZzvPA- {
	cursor: pointer;
	-webkit-user-select: none;
	   -moz-user-select: none;
	        user-select: none;
}

.P0mF0JNmERk- {
	padding: var(--space-small);
	border-top: solid var(--space-minuscule) var(--color-border);
}

.qL0NzJmihKo- {
	box-sizing: border-box;
	width: 100%;
	height: var(--element-height);
	padding-right: var(--space-small);
	padding-left: var(--space-small);

	border: 1px solid var(--color-border-interactive-action-secondary-base);
	border-radius: var(--radius-base);

	outline: none;
	background-color: var(--color-surface-primary);
	color: var(--color-text-primary);
	font-weight: var(--font-weight);
	font-size: var(--font-size);
	line-height: var(--font-line-height-base);
	font-family: var(--font-family-body);
	letter-spacing: var(--font-letter-spacing);
}

.qL0NzJmihKo-[data-hover] {
		border-color: var(--color-border-interactive-action-secondary-hover);
	}

.qL0NzJmihKo-[data-focus] {
		border-color: var(--color-border-interactive-action-primary-active);
	}

.qL0NzJmihKo-[disabled] {
		cursor: not-allowed;
	}

.qL0NzJmihKo-.XUGlCi-QG1w-,.qL0NzJmihKo-.XUGlCi-QG1w-:focus,.qL0NzJmihKo-.XUGlCi-QG1w-:focus-within {
		border-color: var(--color-border-interactive-destruction-primary-hover);
	}

/* Textarea specific styles */

textarea.qL0NzJmihKo- {
		height: auto;
		min-height: calc(var(--element-base) * 2);
		padding-top: var(--space-smaller);
		padding-bottom: var(--space-smaller);
		resize: vertical;
	}

.qL0NzJmihKo-:is(textarea) {
		height: auto;
		min-height: calc(var(--element-base) * 2);
		padding-top: var(--space-smaller);
		padding-bottom: var(--space-smaller);
		resize: vertical;
	}

/* style auto-filled inputs in browsers supporting :autofill and :-webkit-autofill */

.qL0NzJmihKo-:-webkit-autofill {
		background-color: var(--color-surface-primary);
		caret-color: var(--color-text-primary);
		-webkit-text-fill-color: var(--color-text-primary);
		-webkit-box-shadow: 0 0 0px 1000px var(--color-surface-primary) inset;
	}

.qL0NzJmihKo-:autofill {
		background-color: var(--color-surface-primary);
		caret-color: var(--color-text-primary);
		-webkit-text-fill-color: var(--color-text-primary);
		-webkit-box-shadow: 0 0 0px 1000px var(--color-surface-primary) inset;
	}

.qL0NzJmihKo-:is(:-webkit-autofill,:-webkit-autofill) {
		background-color: var(--color-surface-primary);
		caret-color: var(--color-text-primary);
		-webkit-text-fill-color: var(--color-text-primary);
		-webkit-box-shadow: 0 0 0px 1000px var(--color-surface-primary) inset;
	}

.qL0NzJmihKo-:is(:-webkit-autofill,:autofill) {
		background-color: var(--color-surface-primary);
		caret-color: var(--color-text-primary);
		-webkit-text-fill-color: var(--color-text-primary);
		-webkit-box-shadow: 0 0 0px 1000px var(--color-surface-primary) inset;
	}

.qL0NzJmihKo-::-moz-placeholder {
		color: var(--color-border-interactive-action-secondary-base);
	}

.qL0NzJmihKo-::placeholder {
		color: var(--color-border-interactive-action-secondary-base);
	}

.tUSa5fqfouc- {
	display: block;
	margin-bottom: var(--space-smaller);
}

._4l6RDOtHC0Y- {
	--element-height: var(--element-small);
	--font-size: var(--font-size-smallest);
	--font-weight: var(--font-weight-bold);
}

._3G-Eo-8MfKc- {
	--element-height: var(--element-base);
	--font-size: var(--font-size-small);
	--font-weight: var(--font-weight-base);
}

.y-47vZlnzzg- {
	padding-top: var(--space-smaller);
	color: var(--color-text-secondary);
	font-size: var(--font-size-smallest);
	font-family: var(--font-family-body);
}

.y-47vZlnzzg-.XUGlCi-QG1w- {
		color: var(--color-border-interactive-destruction-primary-hover);
	}

.XLgPB38fKeE- {
	width: 100%;
	height: 1px;
	margin: 0;
	border: none;
	background-color: var(--color-border);
}

/* setting base heading */
._6CmGOeaIbZg- {
	margin: 0;
	padding: 0;
	color: var(--color-text-primary);
	font-weight: var(--font-weight-bold);
	font-size: var(--heading-font-size);
	line-height: var(--font-line-height-base);
	font-family: var(--font-family-heading);
	letter-spacing: var(--font-letter-spacing);
	text-align: var(--heading-align);
}
/* level styles */
.Elw-bGPz0E4- {
	--heading-font-size: var(--font-size-extravagant);
}
.kt5-OzrF-wM- {
	--heading-font-size: var(--font-size-largest);
}
.XF3er572Ne8- {
	--heading-font-size: var(--font-size-large);
}
.lkSR-y-fomk- {
	--heading-font-size: var(--font-size-base);
}
/* align styles */
.k6c6xu-mtmA- {
	--heading-align: start;
}
._0yV2Agig-ZI- {
	--heading-align: center;
}
/* line-height styles */
._3oE8rHB-8ac- {
	line-height: var(--font-line-height-small);
}

.PboG40KYFh4- {
	box-sizing: border-box;
	width: 100%;
	height: var(--element-base);
	padding-left: var(--space-small);

	border: 1px solid var(--color-border-interactive-action-secondary-base);
	border-radius: var(--radius-base);

	outline: none;
	background-color: var(--color-surface-primary);
	color: var(--color-text-primary);
	font-weight: var(--font-weight-base);
	font-size: var(--font-size-small);
	line-height: var(--font-line-height-base);
	font-family: var(--font-family-body);
	letter-spacing: var(--font-letter-spacing);
}

.PboG40KYFh4-[data-hover] {
		border-color: var(--color-border-interactive-action-secondary-hover);
	}

.PboG40KYFh4-[data-focus] {
		border-color: var(--color-border-interactive-action-primary-active);
	}

.PboG40KYFh4-[disabled] {
		cursor: not-allowed;
	}

.PboG40KYFh4-._0JLCUUE53-g- {
		border-color: var(--color-border-interactive-destruction-primary-hover);
	}

::-moz-placeholder {
	color: var(--color-border-interactive-action-secondary-base);
}

::placeholder {
	color: var(--color-border-interactive-action-secondary-base);
}

.ggwA8ekro8c- {
	box-sizing: border-box;
	width: var(--input-width);
	padding: var(--space-smaller) 0;
	border: 1px solid var(--color-border);
	border-radius: var(--radius-base);
	background-color: var(--color-surface);
}

._8moNzqhcSRM- {
	padding: var(--space-small) var(--space-base);
	cursor: default;
}

._8moNzqhcSRM-[data-focus] {
		background-color: var(--color-surface-interactive-action-secondary-hover);
	}

._8moNzqhcSRM-[data-selected] {
		background-color: var(--color-surface-interactive-action-primary-base);
	}

._8moNzqhcSRM-[data-selected][data-focus] {
			background-color: var(--color-surface-interactive-action-primary-hover);
		}

.HOi1unxf7tI- > ._8moNzqhcSRM- {
	padding-left: var(--space-large);
}

.L2N0Lk2-Uhg- {
	padding: var(--space-smaller) var(--space-base);
	pointer-events: none;
	touch-action: none;
	-webkit-user-select: none;
	   -moz-user-select: none;
	        user-select: none;
}



.gKEs5OtPqUE- {
	display: inline-flex;
	color: var(--color-text-primary);
}

.gKEs5OtPqUE-:hover {
	cursor: pointer;
}

.OJSsAySjqU0- {
	display: inline-flex;
	width: var(--space-base);
	min-width: var(--space-base);
	height: var(--space-base);
	min-height: var(--space-base);
	border: 1px solid var(--color-text-primary);
	border-radius: var(--radius-base);
}

._8CD-gVt024Q- {
	/* placeholder */
}

._8CD-gVt024Q-:hover {
	cursor: pointer;
}

.V9SECR5ULsA- {
	background-color: var(--color-text-primary);
}

.V9SECR5ULsA- svg {
		visibility: visible;
		align-self: center;
		color: var(--color-surface-primary);
	}

._2tIlaETSias- {
	background-color: transparent;
}

._2tIlaETSias- svg {
		visibility: hidden;
		align-self: center;
	}

.RTPa94lzLk0- {
	color: var(--color-border-interactive-destruction-primary-hover);
}

.kdGWjqJlgHg- {
	--PhoneInputCountryFlag-borderColor: transparent;
	--PhoneInputCountryFlag-borderColor--focus: var(
		--color-border-interactive-action-primary-active
	);
	--PhoneInputCountrySelectArrow-color: var(
		--color-border-interactive-action-secondary-base
	);
	--PhoneInputCountrySelectArrow-opacity: 1;
}
.kdGWjqJlgHg-:focus-within {
		border-color: var(--color-border-interactive-action-primary-active);
	}
.kdGWjqJlgHg-.PhoneInput {
		gap: var(--space-smaller);
	}
.kdGWjqJlgHg- .PhoneInputInput {
		height: 100%;
		padding: 0;
		border: none;
		outline: none;
		background: transparent;
		color: var(--color-text-primary);
	}

._85e08dU05-w- {
	color: var(--color-text-action-base);
}

._85e08dU05-w-:visited {
	color: var(--color-text-action-base);
}

._85e08dU05-w-:hover {
	color: var(--color-text-action-hover);
}

.CXh2JiLW-bA- {
	display: inline-block;
	margin-left: var(--space-smaller);
}

.cqNOcJcI-t4- {
	color: var(--text-color);
}

.cqNOcJcI-t4-  > :first-child {
		margin-top: 0;
	}

.cqNOcJcI-t4-  > :last-child {
		margin-bottom: 0;
	}

._47y2wgbRLp0- {
	margin-top: var(--space-small);
	margin-bottom: var(--space-small);
}

.Of0KGItgKes- {
	margin-left: var(--space-larger);
	margin-right: var(--space-larger);
	margin-top: var(--space-small);
	margin-bottom: var(--space-small);
}

.Of0KGItgKes- * {
		color: var(--color-text-secondary);
	}

.TtMvIlX8Di4- {
	white-space: pre-wrap;
}

.mPDKxwFB9Sc- {
	margin-top: var(--space-small);
	margin-bottom: var(--space-small);
}

.mPDKxwFB9Sc- li {
		margin-left: var(--space-larger);
	}

/* prominence styles */

.jM1VPFNOiks- {
	--text-color: var(--palette-grey-90);
}

.OLGYppnk-9o- {
	--text-color: var(--palette-grey-70);
}

.ooby-e095NI- {
	z-index: var(--elevation-modal);
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;

	color: var(--color-text-primary);
	font-family: var(--font-family-body);
}

.eF83HUv91mg- {
	position: absolute;
	top: 50%;
	left: 50%;
	max-height: 90vh;
	overflow-y: auto;
	translate: -50% -50%;
	border: solid var(--color-border) var(--space-minuscule);
	border-radius: var(--radius-base);
	background-color: var(--color-surface);
	box-shadow: var(--shadow-high);
	word-wrap: break-word;
	overflow-wrap: break-word;
	transition: all var(--timing-base) ease;
}

.eF83HUv91mg-.qHDJ5Y4MRfw- {
	scale: 0.9;
	opacity: 0;
}

.eF83HUv91mg-.wImnBWuOaeA- {
	scale: 0.8;
	opacity: 0;
}

.eF83HUv91mg-.vCfdVw1V6Dk- {
	width: 400px;
	max-width: 70%;
}

.eF83HUv91mg-._0XmKOJ5hDlk- {
	width: 800px;
	max-width: 80%;
}

.eF83HUv91mg-.suJn68jKIwk- {
	width: 1200px;
	max-width: 90%;
}

.eF83HUv91mg-.wNe0eFdKs5E- {
	top: var(--space-extravagant);
	translate: -50% 0%;
}

.iCg-JmudeLo- {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: var(--palette-grey-10);
	opacity: 0.5;
	opacity: 50%;
	transition: all 0.2s ease;
}

.iCg-JmudeLo-.qHDJ5Y4MRfw- {
	opacity: 0;
}

.iCg-JmudeLo-.wImnBWuOaeA- {
	opacity: 0;
}

.wvkeil-1qyM- {
	position: sticky;
	top: 0;
	padding: var(--space-smaller) var(--space-small);
	padding-left: var(--space-large);
	background-color: inherit;
}

.wvkeil-1qyM- h2 {
	margin: 0;
	font-weight: var(--font-weight-base);
	font-size: var(--font-size-base);
	line-height: var(--element-base);
}

.-v31HUSIWD4- {
	border-bottom: var(--space-minuscule) solid var(--color-border);
}

.ow2iCordrK8- {
	font-weight: var(--font-weight-base);
	font-size: var(--font-size-small);
}

.ow2iCordrK8-.EFHYLg-HiXI- {
	max-height: 90%;
	padding: var(--space-large);
}

._4gw63G7IYG0- {
	display: flex;
	align-items: center;
	justify-content: center;
	width: var(--element-base);
	height: var(--element-base);
	border: none;
	border-radius: var(--radius-round);
	background-color: var(--color-surface-interactive-action-secondary-base);
	color: var(--color-text-interactive-action-secondary-base);
	transition: all 0.2s ease;
}

._4gw63G7IYG0-:hover {
	background-color: var(--color-surface-interactive-action-secondary-hover);
	color: var(--color-text-interactive-action-secondary-hover);
}

._4gw63G7IYG0-:active {
	scale: 0.8;
	background-color: var(--color-surface-interactive-action-secondary-hover);
	color: var(--color-text-interactive-action-secondary-hover);
}

.v1ShS1GPN1A- {
	border: solid var(--color-border) var(--space-minuscule);
	border-radius: var(--radius-base);
	background-color: var(--color-surface);
	box-shadow: var(--shadow-high);
}

.v1ShS1GPN1A-.xlCyOAcjM9Y- {
	padding: var(--space-small);
}

/** The Headless UI portal. Consumes the whole screen. */
.g-4ozWstdhk- {
	z-index: var(--elevation-modal);
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;

	color: var(--color-text-primary);
	font-family: var(--font-family-body);
}
/** The part you interact with. */
.AF0RCeS7ePI- {
	position: absolute;
	top: 50%;
	left: 50%;
	width: 400px;

	padding: var(--space-large);
	translate: -50% -50%;

	border: solid var(--color-border) var(--space-minuscule);
	border-radius: var(--radius-base);
	background-color: var(--color-surface);
	word-wrap: break-word;
	overflow-wrap: break-word;
}
/** The background that greys out the rest of the app. */
.TbDgSIgs410- {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: var(--palette-grey-10);
	opacity: 0.5;
	opacity: 50%;
}
.h8Cax1VLlz0- {
	box-sizing: border-box;
	width: 100%;
	height: var(--element-base);
	padding-right: var(--space-small);
	padding-left: var(--space-small);

	border: 1px solid var(--color-border);
	border-radius: var(--radius-base);

	background-color: var(--color-surface);
	color: var(--palette-grey-90);
	font-size: var(--font-size-base);
}
.h8Cax1VLlz0-:focus {
	outline: 2px solid var(--color-border-interactive-action-primary-base);
}
._11cB7mSzTWc- {
	border-color: var(--color-surface-interactive-destruction-primary-base);
}
._11cB7mSzTWc-:focus {
	outline: 2px solid var(--color-border-interactive-destruction-primary-base);
}

.If-pBdcav0Y- {
	display: flex;
	position: relative;
	align-items: center;
	border: 1px solid var(--palette-grey-40);
	border-radius: var(--radius-round);
	cursor: pointer;
	transition: all 0.2s ease;
}

.r6-HjHmLouk- {
	width: calc(var(--space-base) * 2);
	height: calc(var(--element-small) * 0.8);
}

.xw55Ll2fwKM- {
	width: calc(var(--space-base) * 4.2);
	height: var(--element-base);
}

.If-pBdcav0Y-:focus {
	outline: none;
	box-shadow: 0 0 0 var(--space-smallest) var(--palette-green-70);
}

.PH0J7clX0bc- {
	background-color: var(--palette-green-60);
}

._6monBPL3hwY- {
	background-color: var(--palette-grey-50);
}

.e-cSZjkHGw8- {
	cursor: not-allowed;
	opacity: 0.5;
}

._1tTimr6bxwI- {
	display: flex;
	position: absolute;
	align-items: center;
	justify-content: center;
	border-radius: var(--radius-round);
	background-color: var(--palette-white-0);
	transition: transform 0.2s ease;
}

.r6-HjHmLouk- ._1tTimr6bxwI- {
	left: calc(var(--space-small) * 0.3);
	width: calc(var(--space-base) * 0.8);
	height: calc(var(--space-base) * 0.8);
}

.xw55Ll2fwKM- ._1tTimr6bxwI- {
	left: calc(var(--space-small) * 0.8);
	width: calc(var(--space-base) * 1.8);
	height: calc(var(--space-base) * 1.7);
}

.r6-HjHmLouk-.PH0J7clX0bc- ._1tTimr6bxwI- {
	transform: translateX(calc(var(--space-base) * 0.75));
}

.xw55Ll2fwKM-.PH0J7clX0bc- ._1tTimr6bxwI- {
	transform: translateX(calc(var(--space-base) * 1.5));
}

.JS-CLzHa9-I- {
	display: flex;
	align-items: center;
	justify-content: center;
}

.r6-HjHmLouk- .JS-CLzHa9-I- {
	width: calc(var(--space-base) * 0.6);
	height: calc(var(--space-base) * 0.6);
}

.xw55Ll2fwKM- .JS-CLzHa9-I- {
	width: calc(var(--space-base) * 1.25);
	height: calc(var(--space-base) * 1.25);
}

._6monBPL3hwY- .JS-CLzHa9-I- {
	color: var(--palette-grey-50);
}

.PH0J7clX0bc- .JS-CLzHa9-I- {
	color: var(--palette-green-60);
}

/* providing text that is only visible to screen readers */

.y97eHHUd5Ns- {
	position: absolute;
	width: var(--space-miniscule);
	height: var(--space-miniscule);
	margin: -1px;
	padding: 0;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	border-width: 0;
	white-space: nowrap;
}

.AS5JrMjrqbQ- {
	display: flex;
	align-items: center;
	order: -1;
	cursor: pointer;
}

.mKZU5aI8-I8- {
	display: flex;
	align-items: center;
	order: 1;
	cursor: pointer;
}

.e-cSZjkHGw8- + .HLUIVXs3n5w- {
	cursor: not-allowed;
	opacity: 0.5;
}

.YvFE7FqlTS0- {
	color: var(--color-border-interactive-destruction-primary-hover);
}

:root {
	--tab-inset: var(--space-small);
}

.cHJe2HsBNic- {
	display: flex;
	flex-direction: column;
	width: 100%;
	max-height: 100%;
}

.LfIIg9bwrhQ- {
	box-sizing: border-box;
	display: flex;
	position: relative;
	margin-bottom: calc(-1 * var(--space-smallest));
	overflow-x: auto;
	overflow-y: visible;
}

.DEdzikxlAkw- {
	height: var(--element-small);
	margin: 0;
	margin-top: var(--space-small);
	margin-bottom: var(--space-small);
	padding-right: var(--tab-inset);
	padding-left: var(--tab-inset);
	border: none;
	border-radius: var(--radius-base);
	outline: none;
	background: transparent;
	color: var(--color-text-tertiary);
	cursor: pointer;
	text-wrap: nowrap;
}

.DEdzikxlAkw-:first-child {
	margin-left: var(--tab-inset);
}

.DEdzikxlAkw-:last-child {
	margin-right: var(--tab-inset);
}

.DEdzikxlAkw-.VDB94VYoyB0- {
	color: var(--color-text-primary);
}

.DEdzikxlAkw-:hover {
	background-color: var(--color-surface-interactive-action-tertiary-hover);
}

._7GjVSlln9Yc- {
	display: block;
	position: absolute;
	bottom: 0;
	height: var(--space-smallest);
	background-color: var(--color-surface-interactive-action-primary-base);
	transition: all var(--timing-base) ease;
}

.htdKg6As4bY- {
	box-sizing: border-box;
	max-height: 100%;
	overflow-x: hidden;
	overflow-y: "auto";
}

.htdKg6As4bY-.HeJcnz8heHk- {
	padding: var(--space-base);
}

.eQt1Jis30lo- {
	position: relative;
	border-bottom: solid var(--space-smallest) var(--color-border);
}

._6Vf7pQfyKKk-:after,
.jyevrJK7Bcg-:before {
	position: absolute;
	top: 0;
	bottom: 0;
	width: 24px;
	content: "";
}

._6Vf7pQfyKKk-:after {
	right: 0;
	box-shadow: inset -16px 0 16px -16px
		var(--color-border-interactive-action-secondary-base);
}

.jyevrJK7Bcg-:before {
	left: 0;
	box-shadow: inset 16px 0 16px -16px var(--color-border-interactive-action-secondary-base);
}

.feBFPyem0vg- {
	display: inline-flex;
}

._5-yE5oWUWPs- {
	z-index: var(--elevation-tooltip);
}

._-1XZXRLzwUw- {
	padding: var(--space-smaller) var(--space-small);
	border-radius: var(--radius-base);
	background-color: var(--color-surface-secondary);
	fill: var(--color-surface-secondary);
	box-shadow: var(--shadow-base);
}

/* TODO: Find a way to include this at the rollup stage. */
/* This would be a bit better but storybook needs the relative import. */
/* @import "@samdesk/design/src/screen.css"; */
@custom-media --viewport-mobile (max-width: 600px);
@custom-media --viewport-desktop (min-width: 600.02px);
.WJVsKqsNsx4- {
	display: flex;
	max-width: 100%;
	gap: var(--stack-gap);
}
@media (max-width: 600px) {
	.dISGEb-XpGg- {
		flex-direction: column;
	}
}
@media (--viewport-mobile) {
	.dISGEb-XpGg- {
		flex-direction: column;
	}
}
@media (min-width: 600.02px) {
	.EJSTIQ4PYVU- {
		flex-direction: column;
	}
}
@media (--viewport-desktop) {
	.EJSTIQ4PYVU- {
		flex-direction: column;
	}
}
.-MH92ccOyS0- {
	justify-content: flex-start;
}
.fS--JKd4uSo- {
	justify-content: center;
}
.hpG5Y-ugcqs- {
	justify-content: flex-end;
}
._2NLuWqLYdmE- {
	justify-content: stretch;
}
._2NLuWqLYdmE-  > * {
		flex: 1;
	}
.DOfoTDkuOzQ- {
	justify-content: space-between;
}
.wC9U2et5jXM- {
	align-items: flex-start;
}
.-lKy-oIjfG0- {
	align-items: center;
}
.wE6pa1lL70M- {
	align-items: flex-end;
}
.ard80dLr6aw- {
	align-items: stretch;
}
.kVKMsZ5xY9Q- {
	--stack-gap: 0;
}
.NpH57aGewlA- {
	--stack-gap: var(--space-smaller);
}
.hdixyL4lGBA- {
	--stack-gap: var(--space-small);
}
.eajX3-2t-0A- {
	--stack-gap: var(--space-base);
}
.J79pzGu9ZD8- {
	--stack-gap: var(--space-large);
}
.vZDDhzbRF6U- {
	--stack-gap: var(--space-larger);
}
._6StuIuIA76A- {
	flex-wrap: wrap;
}
.UJlW0e-gocc- {
	flex-wrap: nowrap;
}
`, "",{"version":3,"sources":["webpack://./../../packages/components/dist/index.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB;CACC,sBAAsB;CACtB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,uBAAuB;CACvB,kBAAkB;CAClB,+CAA+C;CAC/C,sCAAsC;CACtC,iCAAiC;CACjC,uCAAuC;CACvC,yBAAyB;CACzB,oCAAoC;CACpC,oCAAoC;CACpC,kBAAkB;CAClB,6BAA6B;CAC7B,qBAAqB;CACrB,iBAAiB;CACjB,cAAc;CACd,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,wCAAwC;CACxC,6CAA6C;CAC7C,+BAA+B;AAChC;;AAEA;CACC,yCAAyC;CACzC,8CAA8C;CAC9C,gCAAgC;AACjC;;AAEA;CACC;;;;;;;;;;EAUC;CACD,wDAAwD;CACxD,8CAA8C;CAC9C,iCAAiC;CACjC,mCAAmC;CACnC,4BAA4B;CAC5B,mBAAmB;CACnB,oBAAoB;AACrB;;AAEA;CACC,2CAA2C;CAC3C,gDAAgD;CAChD,kCAAkC;CAClC,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;AACvB;;AAEA,eAAe;;AAEf,qBAAqB;;AAErB;CACC,sEAAsE;CACtE,6EAA6E;CAC7E;;EAEC;CACD;;EAEC;;CAED,gEAAgE;CAChE,uEAAuE;CACvE,yEAAyE;CACzE,6EAA6E;;CAE7E,oEAAoE;CACpE,2EAA2E;CAC3E,6EAA6E;CAC7E;;EAEC;AACF;;AAEA;CACC,wEAAwE;CACxE;;EAEC;CACD;;EAEC;CACD;;EAEC;;CAED,kEAAkE;CAClE,yEAAyE;CACzE,2EAA2E;CAC3E;;EAEC;;CAED,sEAAsE;CACtE,6EAA6E;CAC7E;;EAEC;CACD;;EAEC;AACF;;AAEA;CACC,uEAAuE;CACvE;;EAEC;CACD;;EAEC;CACD;;EAEC;;CAED,iEAAiE;CACjE,wEAAwE;CACxE,0EAA0E;CAC1E;;EAEC;;CAED,qEAAqE;CACrE,4EAA4E;CAC5E;;EAEC;CACD;;EAEC;AACF;;AAEA,eAAe;;AAEf,oBAAoB;;AAEpB;CACC,6BAA6B;AAC9B;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,2EAA2E;CAC3E;;EAEC;CACD;;EAEC;CACD;;EAEC;;CAED,qEAAqE;CACrE,4EAA4E;CAC5E;;EAEC;CACD;;EAEC;;CAED,yEAAyE;CACzE;;EAEC;CACD;;EAEC;CACD;;EAEC;AACF;;AAEA;CACC,6EAA6E;CAC7E;;EAEC;CACD;;EAEC;CACD;;EAEC;;CAED,uEAAuE;CACvE;;EAEC;CACD;;EAEC;CACD;;EAEC;;CAED,2EAA2E;CAC3E;;EAEC;CACD;;EAEC;CACD;;EAEC;AACF;;AAEA;CACC,4EAA4E;CAC5E;;EAEC;CACD;;EAEC;CACD;;EAEC;;CAED,sEAAsE;CACtE,6EAA6E;CAC7E;;EAEC;CACD;;EAEC;;CAED,0EAA0E;CAC1E;;EAEC;CACD;;EAEC;CACD;;EAEC;AACF;;AAEA,eAAe;;AAEf,kBAAkB;;AAElB;CACC,4BAA4B;CAC5B,gDAAgD;CAChD,oCAAoC;AACrC;;AAEA;CACC,2BAA2B;CAC3B,iCAAiC;AAClC;;AAEA,eAAe;;AAEf,UAAU;;AAEV;CACC,WAAW;AACZ;;AAEA;CACC;EACC,wBAAwB;CACzB;;CAEA;EACC,4DAA4D;CAC7D;AACD;;AAEA;CACC,qCAAqC;CACrC,sCAAsC;AACvC;;AAEA;CACC,wBAAwB;CACxB,yBAAyB;AAC1B;;AAEA;CACC,qCAAqC;CACrC,sCAAsC;AACvC;;AAEA;CACC,WAAW;CACX,qCAAqC;CACrC,iCAAiC;CACjC,8CAA8C;AAC/C;;AAEA;GACG,yBAAyB;EAC1B;;AAEF;GACG,yBAAyB;EAC1B;;AAEF;CACC,WAAW;CACX,+BAA+B;CAC/B,6CAA6C;CAC7C,YAAY;CACZ,iCAAiC;CACjC,8CAA8C;AAC/C;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,uDAAuD;CACxD;;AAED;CACC,+BAA+B;CAC/B,yEAAyE;CACzE,eAAe;AAChB;;AAEA;CACC,uCAAuC;AACxC;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4CAA4C;AAC7C;;AAEA;CACC,uBAAuB;CACvB,iBAAiB;CACjB,mBAAmB;CACnB,iCAAiC;CACjC,iCAAiC;CACjC,8CAA8C;AAC/C;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,uCAAuC;AACxC;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,qCAAqC;AACtC;;AAEA,sBAAsB;AACtB;CACC,WAAW;CACX,qCAAqC;CACrC,wBAAwB;CACxB,oCAAoC;CACpC,gCAAgC;CAChC,oCAAoC;CACpC,oCAAoC;CACpC,0CAA0C;CAC1C,6BAA6B;CAC7B,4CAA4C;CAC5C,oCAAoC;CACpC,kCAAkC;AACnC;AACA,sBAAsB;AACtB;CACC,uCAAuC;AACxC;AACA;CACC,yCAAyC;AAC1C;AACA;CACC,wCAAwC;AACzC;AACA,aAAa;AACb;CACC,wCAAwC;AACzC;AACA;CACC,2CAA2C;AAC5C;AACA,iBAAiB;AACjB;CACC,cAAc;CACd,mBAAmB;AACpB;AACA;CACC,cAAc;CACd,oBAAoB;AACrB;AACA;CACC,cAAc;CACd,iBAAiB;AAClB;AACA,gBAAgB;AAChB;CACC,2CAA2C;AAC5C;AACA;CACC,2CAA2C;AAC5C;AACA,gBAAgB;AAChB;CACC,gDAAgD;AACjD;AACA;CACC,gDAAgD;AACjD;AACA,uBAAuB;AACvB;CACC,cAAc;CACd,0BAA0B;CAC1B,8BAA8B;CAC9B,kCAAkC;AACnC;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,4BAA4B;AAC7B;AACA,mBAAmB;AACnB;CACC,eAAe;AAChB;AACA;CACC,qCAAqC;AACtC;AACA;CACC,mCAAmC;AACpC;AACA;CACC,sCAAsC;AACvC;AACA;CACC,qCAAqC;AACtC;;AAEA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,wDAAwD;CACxD,iCAAiC;AAClC;;AAEA;CACC,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;CAC3B,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,yBAAyB;IACtB,sBAAsB;SACjB,iBAAiB;AAC1B;;AAEA;CACC,2BAA2B;CAC3B,4DAA4D;AAC7D;;AAEA;CACC,sBAAsB;CACtB,WAAW;CACX,6BAA6B;CAC7B,iCAAiC;CACjC,gCAAgC;;CAEhC,uEAAuE;CACvE,iCAAiC;;CAEjC,aAAa;CACb,8CAA8C;CAC9C,gCAAgC;CAChC,+BAA+B;CAC/B,2BAA2B;CAC3B,yCAAyC;CACzC,oCAAoC;CACpC,0CAA0C;AAC3C;;AAEA;EACE,oEAAoE;CACrE;;AAED;EACE,mEAAmE;CACpE;;AAED;EACE,mBAAmB;CACpB;;AAED;EACE,uEAAuE;CACxE;;AAED,6BAA6B;;AAE7B;EACE,YAAY;EACZ,yCAAyC;EACzC,iCAAiC;EACjC,oCAAoC;EACpC,gBAAgB;CACjB;;AAED;EACE,YAAY;EACZ,yCAAyC;EACzC,iCAAiC;EACjC,oCAAoC;EACpC,gBAAgB;CACjB;;AAED,oFAAoF;;AAEpF;EACE,8CAA8C;EAC9C,sCAAsC;EACtC,kDAAkD;EAClD,qEAAqE;CACtE;;AAED;EACE,8CAA8C;EAC9C,sCAAsC;EACtC,kDAAkD;EAClD,qEAAqE;CACtE;;AAED;EACE,8CAA8C;EAC9C,sCAAsC;EACtC,kDAAkD;EAClD,qEAAqE;CACtE;;AAED;EACE,8CAA8C;EAC9C,sCAAsC;EACtC,kDAAkD;EAClD,qEAAqE;CACtE;;AAED;EACE,4DAA4D;CAC7D;;AAED;EACE,4DAA4D;CAC7D;;AAED;CACC,cAAc;CACd,mCAAmC;AACpC;;AAEA;CACC,sCAAsC;CACtC,sCAAsC;CACtC,sCAAsC;AACvC;;AAEA;CACC,qCAAqC;CACrC,mCAAmC;CACnC,sCAAsC;AACvC;;AAEA;CACC,iCAAiC;CACjC,kCAAkC;CAClC,oCAAoC;CACpC,oCAAoC;AACrC;;AAEA;EACE,gEAAgE;CACjE;;AAED;CACC,WAAW;CACX,WAAW;CACX,SAAS;CACT,YAAY;CACZ,qCAAqC;AACtC;;AAEA,yBAAyB;AACzB;CACC,SAAS;CACT,UAAU;CACV,gCAAgC;CAChC,oCAAoC;CACpC,mCAAmC;CACnC,yCAAyC;CACzC,uCAAuC;CACvC,0CAA0C;CAC1C,gCAAgC;AACjC;AACA,iBAAiB;AACjB;CACC,iDAAiD;AAClD;AACA;CACC,6CAA6C;AAC9C;AACA;CACC,2CAA2C;AAC5C;AACA;CACC,0CAA0C;AAC3C;AACA,iBAAiB;AACjB;CACC,sBAAsB;AACvB;AACA;CACC,uBAAuB;AACxB;AACA,uBAAuB;AACvB;CACC,0CAA0C;AAC3C;;AAEA;CACC,sBAAsB;CACtB,WAAW;CACX,2BAA2B;CAC3B,gCAAgC;;CAEhC,uEAAuE;CACvE,iCAAiC;;CAEjC,aAAa;CACb,8CAA8C;CAC9C,gCAAgC;CAChC,oCAAoC;CACpC,iCAAiC;CACjC,yCAAyC;CACzC,oCAAoC;CACpC,0CAA0C;AAC3C;;AAEA;EACE,oEAAoE;CACrE;;AAED;EACE,mEAAmE;CACpE;;AAED;EACE,mBAAmB;CACpB;;AAED;EACE,uEAAuE;CACxE;;AAED;CACC,4DAA4D;AAC7D;;AAEA;CACC,4DAA4D;AAC7D;;AAEA;CACC,sBAAsB;CACtB,yBAAyB;CACzB,+BAA+B;CAC/B,qCAAqC;CACrC,iCAAiC;CACjC,sCAAsC;AACvC;;AAEA;CACC,6CAA6C;CAC7C,eAAe;AAChB;;AAEA;EACE,yEAAyE;CAC1E;;AAED;EACE,sEAAsE;CACvE;;AAED;GACG,uEAAuE;EACxE;;AAEF;CACC,gCAAgC;AACjC;;AAEA;CACC,+CAA+C;CAC/C,oBAAoB;CACpB,kBAAkB;CAClB,yBAAyB;IACtB,sBAAsB;SACjB,iBAAiB;AAC1B;;;;AAIA;CACC,oBAAoB;CACpB,gCAAgC;AACjC;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,oBAAoB;CACpB,wBAAwB;CACxB,4BAA4B;CAC5B,yBAAyB;CACzB,6BAA6B;CAC7B,2CAA2C;CAC3C,iCAAiC;AAClC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;CACpC;;AAED;CACC,6BAA6B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;CACnB;;AAED;CACC,gEAAgE;AACjE;;AAEA;CACC,gDAAgD;CAChD;;EAEC;CACD;;EAEC;CACD,yCAAyC;AAC1C;AACA;EACE,mEAAmE;CACpE;AACD;EACE,yBAAyB;CAC1B;AACD;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,gCAAgC;CACjC;;AAED;CACC,oCAAoC;AACrC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,qBAAqB;CACrB,iCAAiC;AAClC;;AAEA;CACC,wBAAwB;AACzB;;AAEA;EACE,aAAa;CACd;;AAED;EACE,gBAAgB;CACjB;;AAED;CACC,8BAA8B;CAC9B,iCAAiC;AAClC;;AAEA;CACC,gCAAgC;CAChC,iCAAiC;CACjC,8BAA8B;CAC9B,iCAAiC;AAClC;;AAEA;EACE,kCAAkC;CACnC;;AAED;CACC,qBAAqB;AACtB;;AAEA;CACC,8BAA8B;CAC9B,iCAAiC;AAClC;;AAEA;EACE,gCAAgC;CACjC;;AAED,sBAAsB;;AAEtB;CACC,oCAAoC;AACrC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,+BAA+B;CAC/B,eAAe;CACf,MAAM;CACN,QAAQ;CACR,SAAS;CACT,OAAO;;CAEP,gCAAgC;CAChC,oCAAoC;AACrC;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,gBAAgB;CAChB,gBAAgB;CAChB,oBAAoB;CACpB,wDAAwD;CACxD,iCAAiC;CACjC,sCAAsC;CACtC,8BAA8B;CAC9B,qBAAqB;CACrB,yBAAyB;CACzB,uCAAuC;AACxC;;AAEA;CACC,UAAU;CACV,UAAU;AACX;;AAEA;CACC,UAAU;CACV,UAAU;AACX;;AAEA;CACC,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,aAAa;CACb,cAAc;AACf;;AAEA;CACC,6BAA6B;CAC7B,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,SAAS;CACT,OAAO;CACP,wCAAwC;CACxC,YAAY;CACZ,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,gBAAgB;CAChB,MAAM;CACN,gDAAgD;CAChD,gCAAgC;CAChC,yBAAyB;AAC1B;;AAEA;CACC,SAAS;CACT,oCAAoC;CACpC,gCAAgC;CAChC,gCAAgC;AACjC;;AAEA;CACC,+DAA+D;AAChE;;AAEA;CACC,oCAAoC;CACpC,iCAAiC;AAClC;;AAEA;CACC,eAAe;CACf,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,0BAA0B;CAC1B,2BAA2B;CAC3B,YAAY;CACZ,kCAAkC;CAClC,wEAAwE;CACxE,0DAA0D;CAC1D,yBAAyB;AAC1B;;AAEA;CACC,yEAAyE;CACzE,2DAA2D;AAC5D;;AAEA;CACC,UAAU;CACV,yEAAyE;CACzE,2DAA2D;AAC5D;;AAEA;CACC,wDAAwD;CACxD,iCAAiC;CACjC,sCAAsC;CACtC,8BAA8B;AAC/B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA,wDAAwD;AACxD;CACC,+BAA+B;CAC/B,eAAe;CACf,MAAM;CACN,QAAQ;CACR,SAAS;CACT,OAAO;;CAEP,gCAAgC;CAChC,oCAAoC;AACrC;AACA,iCAAiC;AACjC;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,YAAY;;CAEZ,2BAA2B;CAC3B,oBAAoB;;CAEpB,wDAAwD;CACxD,iCAAiC;CACjC,sCAAsC;CACtC,qBAAqB;CACrB,yBAAyB;AAC1B;AACA,wDAAwD;AACxD;CACC,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,SAAS;CACT,OAAO;CACP,wCAAwC;CACxC,YAAY;CACZ,YAAY;AACb;AACA;CACC,sBAAsB;CACtB,WAAW;CACX,2BAA2B;CAC3B,iCAAiC;CACjC,gCAAgC;;CAEhC,qCAAqC;CACrC,iCAAiC;;CAEjC,sCAAsC;CACtC,6BAA6B;CAC7B,gCAAgC;AACjC;AACA;CACC,sEAAsE;AACvE;AACA;CACC,uEAAuE;AACxE;AACA;CACC,2EAA2E;AAC5E;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,mBAAmB;CACnB,wCAAwC;CACxC,kCAAkC;CAClC,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,kCAAkC;CAClC,wCAAwC;AACzC;;AAEA;CACC,oCAAoC;CACpC,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,+DAA+D;AAChE;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,mBAAmB;CACnB,uBAAuB;CACvB,kCAAkC;CAClC,wCAAwC;CACxC,+BAA+B;AAChC;;AAEA;CACC,oCAAoC;CACpC,oCAAoC;CACpC,qCAAqC;AACtC;;AAEA;CACC,oCAAoC;CACpC,oCAAoC;CACpC,qCAAqC;AACtC;;AAEA;CACC,qDAAqD;AACtD;;AAEA;CACC,oDAAoD;AACrD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,oCAAoC;CACpC,qCAAqC;AACtC;;AAEA;CACC,qCAAqC;CACrC,sCAAsC;AACvC;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0DAA0D;;AAE1D;CACC,kBAAkB;CAClB,6BAA6B;CAC7B,8BAA8B;CAC9B,YAAY;CACZ,UAAU;CACV,gBAAgB;CAChB,sBAAsB;CACtB,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,gEAAgE;AACjE;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;CACtB,aAAa;CACb,kBAAkB;CAClB,+CAA+C;CAC/C,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,4BAA4B;CAC5B,SAAS;CACT,8BAA8B;CAC9B,iCAAiC;CACjC,+BAA+B;CAC/B,8BAA8B;CAC9B,YAAY;CACZ,iCAAiC;CACjC,aAAa;CACb,uBAAuB;CACvB,iCAAiC;CACjC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,wEAAwE;AACzE;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,SAAS;CACT,6BAA6B;CAC7B,sEAAsE;CACtE,uCAAuC;AACxC;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,8DAA8D;AAC/D;;AAEA;;CAEC,kBAAkB;CAClB,MAAM;CACN,SAAS;CACT,WAAW;CACX,WAAW;AACZ;;AAEA;CACC,QAAQ;CACR;uDACsD;AACvD;;AAEA;CACC,OAAO;CACP,yFAAyF;AAC1F;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,gDAAgD;CAChD,iCAAiC;CACjC,gDAAgD;CAChD,oCAAoC;CACpC,8BAA8B;AAC/B;;AAEA,0DAA0D;AAC1D,wEAAwE;AACxE,8CAA8C;AAC9C,kDAAkD;AAClD,sDAAsD;AACtD;CACC,aAAa;CACb,eAAe;CACf,qBAAqB;AACtB;AACA;CACC;EACC,sBAAsB;CACvB;AACD;AACA;CACC;EACC,sBAAsB;CACvB;AACD;AACA;CACC;EACC,sBAAsB;CACvB;AACD;AACA;CACC;EACC,sBAAsB;CACvB;AACD;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,uBAAuB;AACxB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,wBAAwB;AACzB;AACA;EACE,OAAO;CACR;AACD;CACC,8BAA8B;AAC/B;AACA;CACC,uBAAuB;AACxB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,cAAc;AACf;AACA;CACC,iCAAiC;AAClC;AACA;CACC,+BAA+B;AAChC;AACA;CACC,8BAA8B;AAC/B;AACA;CACC,+BAA+B;AAChC;AACA;CACC,gCAAgC;AACjC;AACA;CACC,eAAe;AAChB;AACA;CACC,iBAAiB;AAClB","sourcesContent":["/* #region Button */\n\n.xR6SxM6JOYE- {\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: -moz-fit-content;\n\twidth: fit-content;\n\tpadding: var(--space-smaller) var(--space-base);\n\tborder: 1px solid var(--button-border);\n\tborder-radius: var(--radius-base);\n\tbackground-color: var(--button-surface);\n\tcolor: var(--button-text);\n\tfont-weight: var(--font-weight-base);\n\tfont-family: var(--font-family-body);\n\ttext-align: center;\n\t-webkit-text-decoration: none;\n\ttext-decoration: none;\n\ttext-wrap: nowrap;\n\tline-height: 0;\n\tcursor: pointer;\n\ttransition: all 0.2s ease;\n}\n\n.xR6SxM6JOYE-:hover {\n\tborder-color: var(--button-border-hover);\n\tbackground-color: var(--button-surface-hover);\n\tcolor: var(--button-text-hover);\n}\n\n.xR6SxM6JOYE-:active {\n\tborder-color: var(--button-border-active);\n\tbackground-color: var(--button-surface-active);\n\tcolor: var(--button-text-active);\n}\n\n.xR6SxM6JOYE-.NCs-BISj1XU-:not(:disabled) {\n\tbackground-image: linear-gradient(\n\t\t135deg,\n\t\trgba(0, 0, 0, 0.1) 0%,\n\t\trgba(0, 0, 0, 0.1) 25%,\n\t\ttransparent 25%,\n\t\ttransparent 50%,\n\t\trgba(0, 0, 0, 0.1) 50%,\n\t\trgba(0, 0, 0, 0.1) 75%,\n\t\ttransparent 75%,\n\t\ttransparent 100%\n\t);\n\tbackground-size: var(--space-larger) var(--space-larger);\n\tanimation-duration: var(--timing-loading-slow);\n\tanimation-timing-function: linear;\n\tanimation-iteration-count: infinite;\n\tanimation-name: M0LU-Rdq-MA-;\n\tcursor: not-allowed;\n\tpointer-events: none;\n}\n\n.xR6SxM6JOYE-:disabled {\n\tborder-color: var(--button-border-disabled);\n\tbackground-color: var(--button-surface-disabled);\n\tcolor: var(--button-text-disabled);\n\tcursor: not-allowed;\n}\n\n.-Ibb742Q6ck- {\n\tjustify-content: start;\n}\n\n/* #endregion */\n\n/* #region variants */\n\n.TrzCxs3OEpM- {\n\t--button-surface: var(--color-surface-interactive-action-primary-base);\n\t--button-surface-hover: var(--color-surface-interactive-action-primary-hover);\n\t--button-surface-active: var(\n\t\t--color-surface-interactive-action-primary-active\n\t);\n\t--button-surface-disabled: var(\n\t\t--color-surface-interactive-action-primary-disabled\n\t);\n\n\t--button-text: var(--color-text-interactive-action-primary-base);\n\t--button-text-hover: var(--color-text-interactive-action-primary-hover);\n\t--button-text-active: var(--color-text-interactive-action-primary-active);\n\t--button-text-disabled: var(--color-text-interactive-action-primary-disabled);\n\n\t--button-border: var(--color-border-interactive-action-primary-base);\n\t--button-border-hover: var(--color-border-interactive-action-primary-hover);\n\t--button-border-active: var(--color-border-interactive-action-primary-active);\n\t--button-border-disabled: var(\n\t\t--color-border-interactive-action-primary-disabled\n\t);\n}\n\n.QaWL8FLJ5Aw- {\n\t--button-surface: var(--color-surface-interactive-action-secondary-base);\n\t--button-surface-hover: var(\n\t\t--color-surface-interactive-action-secondary-hover\n\t);\n\t--button-surface-active: var(\n\t\t--color-surface-interactive-action-secondary-active\n\t);\n\t--button-surface-disabled: var(\n\t\t--color-surface-interactive-action-prsecondaryimary-disabled\n\t);\n\n\t--button-text: var(--color-text-interactive-action-secondary-base);\n\t--button-text-hover: var(--color-text-interactive-action-secondary-hover);\n\t--button-text-active: var(--color-text-interactive-action-secondary-active);\n\t--button-text-disabled: var(\n\t\t--color-text-interactive-action-secondary-disabled\n\t);\n\n\t--button-border: var(--color-border-interactive-action-secondary-base);\n\t--button-border-hover: var(--color-border-interactive-action-secondary-hover);\n\t--button-border-active: var(\n\t\t--color-border-interactive-action-secondary-active\n\t);\n\t--button-border-disabled: var(\n\t\t--color-border-interactive-action-secondary-disabled\n\t);\n}\n\n.MhDYVRl8PUc- {\n\t--button-surface: var(--color-surface-interactive-action-tertiary-base);\n\t--button-surface-hover: var(\n\t\t--color-surface-interactive-action-tertiary-hover\n\t);\n\t--button-surface-active: var(\n\t\t--color-surface-interactive-action-tertiary-active\n\t);\n\t--button-surface-disabled: var(\n\t\t--color-surface-interactive-action-tertiary-disabled\n\t);\n\n\t--button-text: var(--color-text-interactive-action-tertiary-base);\n\t--button-text-hover: var(--color-text-interactive-action-tertiary-hover);\n\t--button-text-active: var(--color-text-interactive-action-tertiary-active);\n\t--button-text-disabled: var(\n\t\t--color-text-interactive-action-tertiary-disabled\n\t);\n\n\t--button-border: var(--color-border-interactive-action-tertiary-base);\n\t--button-border-hover: var(--color-border-interactive-action-tertiary-hover);\n\t--button-border-active: var(\n\t\t--color-border-interactive-action-tertiary-active\n\t);\n\t--button-border-disabled: var(\n\t\t--color-border-interactive-action-tertiary-disabled\n\t);\n}\n\n/* #endregion */\n\n/* #region intents */\n\n.v-Wis6ruH-8- {\n\t/* Base  for action buttons */\n}\n\n.kH2lHqHWQrI- {\n\t/* Base for destruction buttons */\n}\n\n.kH2lHqHWQrI-.TrzCxs3OEpM- {\n\t--button-surface: var(--color-surface-interactive-destruction-primary-base);\n\t--button-surface-hover: var(\n\t\t--color-surface-interactive-destruction-primary-hover\n\t);\n\t--button-surface-active: var(\n\t\t--color-surface-interactive-destruction-primary-active\n\t);\n\t--button-surface-disabled: var(\n\t\t--color-surface-interactive-destruction-primary-disabled\n\t);\n\n\t--button-text: var(--color-text-interactive-destruction-primary-base);\n\t--button-text-hover: var(--color-text-interactive-destruction-primary-hover);\n\t--button-text-active: var(\n\t\t--color-text-interactive-destruction-primary-active\n\t);\n\t--button-text-disabled: var(\n\t\t--color-text-interactive-destruction-primary-disabled\n\t);\n\n\t--button-border: var(--color-border-interactive-destruction-primary-base);\n\t--button-border-hover: var(\n\t\t--color-border-interactive-destruction-primary-hover\n\t);\n\t--button-border-active: var(\n\t\t--color-border-interactive-destruction-primary-active\n\t);\n\t--button-border-disabled: var(\n\t\t--color-border-interactive-destruction-primary-disabled\n\t);\n}\n\n.kH2lHqHWQrI-.QaWL8FLJ5Aw- {\n\t--button-surface: var(--color-surface-interactive-destruction-secondary-base);\n\t--button-surface-hover: var(\n\t\t--color-surface-interactive-destruction-secondary-hover\n\t);\n\t--button-surface-active: var(\n\t\t--color-surface-interactive-destruction-secondary-active\n\t);\n\t--button-surface-disabled: var(\n\t\t--color-surface-interactive-destruction-secondary-disabled\n\t);\n\n\t--button-text: var(--color-text-interactive-destruction-secondary-base);\n\t--button-text-hover: var(\n\t\t--color-text-interactive-destruction-secondary-hover\n\t);\n\t--button-text-active: var(\n\t\t--color-text-interactive-destruction-secondary-active\n\t);\n\t--button-text-disabled: var(\n\t\t--color-text-interactive-destruction-secondary-disabled\n\t);\n\n\t--button-border: var(--color-border-interactive-destruction-secondary-base);\n\t--button-border-hover: var(\n\t\t--color-border-interactive-destruction-secondary-hover\n\t);\n\t--button-border-active: var(\n\t\t--color-border-interactive-destruction-secondary-active\n\t);\n\t--button-border-disabled: var(\n\t\t--color-border-interactive-destruction-secondary-disabled\n\t);\n}\n\n.kH2lHqHWQrI-.MhDYVRl8PUc- {\n\t--button-surface: var(--color-surface-interactive-destruction-tertiary-base);\n\t--button-surface-hover: var(\n\t\t--color-surface-interactive-destruction-tertiary-hover\n\t);\n\t--button-surface-active: var(\n\t\t--color-surface-interactive-destruction-tertiary-active\n\t);\n\t--button-surface-disabled: var(\n\t\t--color-surface-interactive-destruction-tertiary-disabled\n\t);\n\n\t--button-text: var(--color-text-interactive-destruction-tertiary-base);\n\t--button-text-hover: var(--color-text-interactive-destruction-tertiary-hover);\n\t--button-text-active: var(\n\t\t--color-text-interactive-destruction-tertiary-active\n\t);\n\t--button-text-disabled: var(\n\t\t--color-text-interactive-destruction-tertiary-disabled\n\t);\n\n\t--button-border: var(--color-border-interactive-destruction-tertiary-base);\n\t--button-border-hover: var(\n\t\t--color-border-interactive-destruction-tertiary-hover\n\t);\n\t--button-border-active: var(\n\t\t--color-border-interactive-destruction-tertiary-active\n\t);\n\t--button-border-disabled: var(\n\t\t--color-border-interactive-destruction-tertiary-disabled\n\t);\n}\n\n/* #endregion */\n\n/* #region sizes */\n\n.lPPuBfTJl5k- {\n\theight: var(--element-small);\n\tpadding: var(--space-smaller) var(--space-small);\n\tfont-size: var(--font-size-smallest);\n}\n\n.VyMJpVxCrxI- {\n\theight: var(--element-base);\n\tfont-size: var(--font-size-small);\n}\n\n/* #endregion */\n\n/* other */\n\n.yBId-F-geAA- {\n\twidth: 100%;\n}\n\n@keyframes M0LU-Rdq-MA- {\n\t0% {\n\t\tbackground-position: 0 0;\n\t}\n\n\t100% {\n\t\tbackground-position: var(--space-larger) var(--space-larger);\n\t}\n}\n\n.gWgLCEdx90Q- {\n\twidth: calc(var(--space-small) * 1.5);\n\theight: calc(var(--space-small) * 1.5);\n}\n\n.NukXJ1ku9MQ- {\n\twidth: var(--space-base);\n\theight: var(--space-base);\n}\n\n.D2y5sdKc6Hs- {\n\twidth: calc(var(--space-base) * 1.25);\n\theight: calc(var(--space-base) * 1.25);\n}\n\n.EJ0Npu8swS8- {\n\twidth: 100%;\n\tborder: 1px solid var(--color-border);\n\tborder-radius: var(--radius-base);\n\tbackground-color: var(--color-surface-primary);\n}\n\n.EJ0Npu8swS8-[data-open] .CJjRz-TW4r4- svg {\n\t\t\ttransform: rotate(180deg);\n\t\t}\n\n:is(.EJ0Npu8swS8-[data-open] .CJjRz-TW4r4-) svg {\n\t\t\ttransform: rotate(180deg);\n\t\t}\n\n.CJjRz-TW4r4- {\n\twidth: 100%;\n\tmin-height: var(--element-base);\n\tpadding: var(--space-small) var(--space-base);\n\tborder: none;\n\tborder-radius: var(--radius-base);\n\tbackground-color: var(--color-surface-primary);\n}\n\n.CJjRz-TW4r4- svg {\n\t\tflex-shrink: 0;\n\t\tcolor: var(--color-text-tertiary);\n\t\ttransition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n\t}\n\n.CJjRz-TW4r4-:hover {\n\tmin-height: var(--element-base);\n\tbackground-color: var(--color-surface-interactive-action-tertiary-active);\n\tcursor: pointer;\n}\n\n.-NZesrNGdMg- {\n\tpadding: var(--accordion-panel-padding);\n}\n\n.Y-38p-yYvkA- {\n\t--accordion-panel-padding: 0;\n}\n\n.ynbo7clC9nY- {\n\t--accordion-panel-padding: var(--space-base);\n}\n\n.V8ZCH4DJl54- {\n\tpadding: var(--spacing);\n\tborder-width: 1px;\n\tborder-style: solid;\n\tborder-radius: var(--radius-base);\n\tborder-color: var(--border-color);\n\tbackground-color: var(--color-surface-primary);\n}\n\n.UFdyLFofW7A- {\n\t--spacing: var(--space-large);\n}\n\n.Xn-MPG-KQoE- {\n\t--spacing: var(--space-base);\n}\n\n._7SG16IZ9dDI- {\n\t--spacing: var(--space-small);\n}\n\n.L1bJQuvLkl8- {\n\t--spacing: 0;\n}\n\n.u17T1FOCIUQ- {\n\t--border-color: var(--color-border-primary);\n}\n\n._6pB1Tcbnvp4- {\n\t--border-color: transparent;\n}\n\n.kWv7qiYlz48- {\n\t--border-color: var(--palette-green-70);\n}\n\n.nGNDuV2zBXI- {\n\t--border-color: var(--palette-orange-70);\n}\n\n.zbvTuS5uibw- {\n\t--border-color: var(--palette-red-70);\n}\n\n/* setting base text */\n._0ima0sD4M-o- {\n\tmargin: 0px;\n\toverflow: var(--text-overflow-hidden);\n\tcolor: var(--text-color);\n\tfont-weight: var(--text-font-weight);\n\tfont-size: var(--text-font-size);\n\tline-height: var(--text-line-height);\n\tfont-family: var(--font-family-body);\n\tletter-spacing: var(--font-letter-spacing);\n\ttext-align: var(--text-align);\n\ttext-overflow: var(--text-overflow-ellipsis);\n\twhite-space: var(--text-white-space);\n\tword-break: var(--text-word-break);\n}\n/* prominence styles */\n.QQ3Dge26-a8- {\n\t--text-color: var(--color-text-primary);\n}\n.QfA-XyVS1U0- {\n\t--text-color: var(--color-text-secondary);\n}\n.DfNfnH2JAfk- {\n\t--text-color: var(--color-text-tertiary);\n}\n/* variants */\n.o-QuIx39eRI- {\n\t--text-font-size: var(--font-size-small);\n}\n.e7L25fWiQDk- {\n\t--text-font-size: var(--font-size-smallest);\n}\n/* align styles */\n._8EFOxhgOzbA- {\n\tdisplay: block;\n\t--text-align: start;\n}\n.PEQQNIhwx7w- {\n\tdisplay: block;\n\t--text-align: center;\n}\n.Z9E9xYSp3X4- {\n\tdisplay: block;\n\t--text-align: end;\n}\n/* font weight */\n.ftHpA4j7-Mc- {\n\t--text-font-weight: var(--font-weight-base);\n}\n.BP6qSj0jiQA- {\n\t--text-font-weight: var(--font-weight-bold);\n}\n/* line height */\n.jCgA1vmWNCM- {\n\t--text-line-height: var(--font-line-height-base);\n}\n.xYqF6hAsEYY- {\n\t--text-line-height: var(--font-line-height-none);\n}\n/* formatting options */\n.fpMmxsNRc68- {\n\tdisplay: block;\n\t--text-white-space: nowrap;\n\t--text-overflow-hidden: hidden;\n\t--text-overflow-ellipsis: ellipsis;\n}\n.h4KhTBuOV-M- {\n\t--text-white-space: nowrap;\n}\n.EwzHK14Sxeg- {\n\t--text-word-break: break-all;\n}\n/* accent colours */\n._9fnywQ6dkZ4- {\n\t/* placehoder */\n}\n.MibWHGrARRY- {\n\t--text-color: var(--palette-green-70);\n}\n.zrR5yh9ZQnY- {\n\t--text-color: var(--palette-red-70);\n}\n.JFZM0Zl-PEM- {\n\t--text-color: var(--palette-orange-70);\n}\n.snFkDfEXyyI- {\n\t--text-color: var(--palette-green-70);\n}\n\n.HTLeNI1dHkw- {\n\twidth: 100%;\n\tmax-width: 100%;\n\toverflow-y: auto;\n\tborder: solid var(--space-minuscule) var(--color-border);\n\tborder-radius: var(--radius-base);\n}\n\n.RSD-fmW5tBs- {\n\twidth: 100%;\n\tmax-width: 100%;\n\tborder-spacing: 0;\n\ttext-align: left;\n\ttable-layout: fixed;\n}\n\n._1rjFYQERgMM- {\n\ttext-align: left;\n}\n\n.c7Tce3P-ZPE- {\n\tpadding: var(--space-small);\n\tborder: none;\n\tbackground: none;\n\ttext-align: left;\n}\n\n.c7Tce3P-ZPE-._804fMFZzvPA- {\n\tcursor: pointer;\n\t-webkit-user-select: none;\n\t   -moz-user-select: none;\n\t        user-select: none;\n}\n\n.P0mF0JNmERk- {\n\tpadding: var(--space-small);\n\tborder-top: solid var(--space-minuscule) var(--color-border);\n}\n\n.qL0NzJmihKo- {\n\tbox-sizing: border-box;\n\twidth: 100%;\n\theight: var(--element-height);\n\tpadding-right: var(--space-small);\n\tpadding-left: var(--space-small);\n\n\tborder: 1px solid var(--color-border-interactive-action-secondary-base);\n\tborder-radius: var(--radius-base);\n\n\toutline: none;\n\tbackground-color: var(--color-surface-primary);\n\tcolor: var(--color-text-primary);\n\tfont-weight: var(--font-weight);\n\tfont-size: var(--font-size);\n\tline-height: var(--font-line-height-base);\n\tfont-family: var(--font-family-body);\n\tletter-spacing: var(--font-letter-spacing);\n}\n\n.qL0NzJmihKo-[data-hover] {\n\t\tborder-color: var(--color-border-interactive-action-secondary-hover);\n\t}\n\n.qL0NzJmihKo-[data-focus] {\n\t\tborder-color: var(--color-border-interactive-action-primary-active);\n\t}\n\n.qL0NzJmihKo-[disabled] {\n\t\tcursor: not-allowed;\n\t}\n\n.qL0NzJmihKo-.XUGlCi-QG1w-,.qL0NzJmihKo-.XUGlCi-QG1w-:focus,.qL0NzJmihKo-.XUGlCi-QG1w-:focus-within {\n\t\tborder-color: var(--color-border-interactive-destruction-primary-hover);\n\t}\n\n/* Textarea specific styles */\n\ntextarea.qL0NzJmihKo- {\n\t\theight: auto;\n\t\tmin-height: calc(var(--element-base) * 2);\n\t\tpadding-top: var(--space-smaller);\n\t\tpadding-bottom: var(--space-smaller);\n\t\tresize: vertical;\n\t}\n\n.qL0NzJmihKo-:is(textarea) {\n\t\theight: auto;\n\t\tmin-height: calc(var(--element-base) * 2);\n\t\tpadding-top: var(--space-smaller);\n\t\tpadding-bottom: var(--space-smaller);\n\t\tresize: vertical;\n\t}\n\n/* style auto-filled inputs in browsers supporting :autofill and :-webkit-autofill */\n\n.qL0NzJmihKo-:-webkit-autofill {\n\t\tbackground-color: var(--color-surface-primary);\n\t\tcaret-color: var(--color-text-primary);\n\t\t-webkit-text-fill-color: var(--color-text-primary);\n\t\t-webkit-box-shadow: 0 0 0px 1000px var(--color-surface-primary) inset;\n\t}\n\n.qL0NzJmihKo-:autofill {\n\t\tbackground-color: var(--color-surface-primary);\n\t\tcaret-color: var(--color-text-primary);\n\t\t-webkit-text-fill-color: var(--color-text-primary);\n\t\t-webkit-box-shadow: 0 0 0px 1000px var(--color-surface-primary) inset;\n\t}\n\n.qL0NzJmihKo-:is(:-webkit-autofill,:-webkit-autofill) {\n\t\tbackground-color: var(--color-surface-primary);\n\t\tcaret-color: var(--color-text-primary);\n\t\t-webkit-text-fill-color: var(--color-text-primary);\n\t\t-webkit-box-shadow: 0 0 0px 1000px var(--color-surface-primary) inset;\n\t}\n\n.qL0NzJmihKo-:is(:-webkit-autofill,:autofill) {\n\t\tbackground-color: var(--color-surface-primary);\n\t\tcaret-color: var(--color-text-primary);\n\t\t-webkit-text-fill-color: var(--color-text-primary);\n\t\t-webkit-box-shadow: 0 0 0px 1000px var(--color-surface-primary) inset;\n\t}\n\n.qL0NzJmihKo-::-moz-placeholder {\n\t\tcolor: var(--color-border-interactive-action-secondary-base);\n\t}\n\n.qL0NzJmihKo-::placeholder {\n\t\tcolor: var(--color-border-interactive-action-secondary-base);\n\t}\n\n.tUSa5fqfouc- {\n\tdisplay: block;\n\tmargin-bottom: var(--space-smaller);\n}\n\n._4l6RDOtHC0Y- {\n\t--element-height: var(--element-small);\n\t--font-size: var(--font-size-smallest);\n\t--font-weight: var(--font-weight-bold);\n}\n\n._3G-Eo-8MfKc- {\n\t--element-height: var(--element-base);\n\t--font-size: var(--font-size-small);\n\t--font-weight: var(--font-weight-base);\n}\n\n.y-47vZlnzzg- {\n\tpadding-top: var(--space-smaller);\n\tcolor: var(--color-text-secondary);\n\tfont-size: var(--font-size-smallest);\n\tfont-family: var(--font-family-body);\n}\n\n.y-47vZlnzzg-.XUGlCi-QG1w- {\n\t\tcolor: var(--color-border-interactive-destruction-primary-hover);\n\t}\n\n.XLgPB38fKeE- {\n\twidth: 100%;\n\theight: 1px;\n\tmargin: 0;\n\tborder: none;\n\tbackground-color: var(--color-border);\n}\n\n/* setting base heading */\n._6CmGOeaIbZg- {\n\tmargin: 0;\n\tpadding: 0;\n\tcolor: var(--color-text-primary);\n\tfont-weight: var(--font-weight-bold);\n\tfont-size: var(--heading-font-size);\n\tline-height: var(--font-line-height-base);\n\tfont-family: var(--font-family-heading);\n\tletter-spacing: var(--font-letter-spacing);\n\ttext-align: var(--heading-align);\n}\n/* level styles */\n.Elw-bGPz0E4- {\n\t--heading-font-size: var(--font-size-extravagant);\n}\n.kt5-OzrF-wM- {\n\t--heading-font-size: var(--font-size-largest);\n}\n.XF3er572Ne8- {\n\t--heading-font-size: var(--font-size-large);\n}\n.lkSR-y-fomk- {\n\t--heading-font-size: var(--font-size-base);\n}\n/* align styles */\n.k6c6xu-mtmA- {\n\t--heading-align: start;\n}\n._0yV2Agig-ZI- {\n\t--heading-align: center;\n}\n/* line-height styles */\n._3oE8rHB-8ac- {\n\tline-height: var(--font-line-height-small);\n}\n\n.PboG40KYFh4- {\n\tbox-sizing: border-box;\n\twidth: 100%;\n\theight: var(--element-base);\n\tpadding-left: var(--space-small);\n\n\tborder: 1px solid var(--color-border-interactive-action-secondary-base);\n\tborder-radius: var(--radius-base);\n\n\toutline: none;\n\tbackground-color: var(--color-surface-primary);\n\tcolor: var(--color-text-primary);\n\tfont-weight: var(--font-weight-base);\n\tfont-size: var(--font-size-small);\n\tline-height: var(--font-line-height-base);\n\tfont-family: var(--font-family-body);\n\tletter-spacing: var(--font-letter-spacing);\n}\n\n.PboG40KYFh4-[data-hover] {\n\t\tborder-color: var(--color-border-interactive-action-secondary-hover);\n\t}\n\n.PboG40KYFh4-[data-focus] {\n\t\tborder-color: var(--color-border-interactive-action-primary-active);\n\t}\n\n.PboG40KYFh4-[disabled] {\n\t\tcursor: not-allowed;\n\t}\n\n.PboG40KYFh4-._0JLCUUE53-g- {\n\t\tborder-color: var(--color-border-interactive-destruction-primary-hover);\n\t}\n\n::-moz-placeholder {\n\tcolor: var(--color-border-interactive-action-secondary-base);\n}\n\n::placeholder {\n\tcolor: var(--color-border-interactive-action-secondary-base);\n}\n\n.ggwA8ekro8c- {\n\tbox-sizing: border-box;\n\twidth: var(--input-width);\n\tpadding: var(--space-smaller) 0;\n\tborder: 1px solid var(--color-border);\n\tborder-radius: var(--radius-base);\n\tbackground-color: var(--color-surface);\n}\n\n._8moNzqhcSRM- {\n\tpadding: var(--space-small) var(--space-base);\n\tcursor: default;\n}\n\n._8moNzqhcSRM-[data-focus] {\n\t\tbackground-color: var(--color-surface-interactive-action-secondary-hover);\n\t}\n\n._8moNzqhcSRM-[data-selected] {\n\t\tbackground-color: var(--color-surface-interactive-action-primary-base);\n\t}\n\n._8moNzqhcSRM-[data-selected][data-focus] {\n\t\t\tbackground-color: var(--color-surface-interactive-action-primary-hover);\n\t\t}\n\n.HOi1unxf7tI- > ._8moNzqhcSRM- {\n\tpadding-left: var(--space-large);\n}\n\n.L2N0Lk2-Uhg- {\n\tpadding: var(--space-smaller) var(--space-base);\n\tpointer-events: none;\n\ttouch-action: none;\n\t-webkit-user-select: none;\n\t   -moz-user-select: none;\n\t        user-select: none;\n}\n\n\n\n.gKEs5OtPqUE- {\n\tdisplay: inline-flex;\n\tcolor: var(--color-text-primary);\n}\n\n.gKEs5OtPqUE-:hover {\n\tcursor: pointer;\n}\n\n.OJSsAySjqU0- {\n\tdisplay: inline-flex;\n\twidth: var(--space-base);\n\tmin-width: var(--space-base);\n\theight: var(--space-base);\n\tmin-height: var(--space-base);\n\tborder: 1px solid var(--color-text-primary);\n\tborder-radius: var(--radius-base);\n}\n\n._8CD-gVt024Q- {\n\t/* placeholder */\n}\n\n._8CD-gVt024Q-:hover {\n\tcursor: pointer;\n}\n\n.V9SECR5ULsA- {\n\tbackground-color: var(--color-text-primary);\n}\n\n.V9SECR5ULsA- svg {\n\t\tvisibility: visible;\n\t\talign-self: center;\n\t\tcolor: var(--color-surface-primary);\n\t}\n\n._2tIlaETSias- {\n\tbackground-color: transparent;\n}\n\n._2tIlaETSias- svg {\n\t\tvisibility: hidden;\n\t\talign-self: center;\n\t}\n\n.RTPa94lzLk0- {\n\tcolor: var(--color-border-interactive-destruction-primary-hover);\n}\n\n.kdGWjqJlgHg- {\n\t--PhoneInputCountryFlag-borderColor: transparent;\n\t--PhoneInputCountryFlag-borderColor--focus: var(\n\t\t--color-border-interactive-action-primary-active\n\t);\n\t--PhoneInputCountrySelectArrow-color: var(\n\t\t--color-border-interactive-action-secondary-base\n\t);\n\t--PhoneInputCountrySelectArrow-opacity: 1;\n}\n.kdGWjqJlgHg-:focus-within {\n\t\tborder-color: var(--color-border-interactive-action-primary-active);\n\t}\n.kdGWjqJlgHg-.PhoneInput {\n\t\tgap: var(--space-smaller);\n\t}\n.kdGWjqJlgHg- .PhoneInputInput {\n\t\theight: 100%;\n\t\tpadding: 0;\n\t\tborder: none;\n\t\toutline: none;\n\t\tbackground: transparent;\n\t\tcolor: var(--color-text-primary);\n\t}\n\n._85e08dU05-w- {\n\tcolor: var(--color-text-action-base);\n}\n\n._85e08dU05-w-:visited {\n\tcolor: var(--color-text-action-base);\n}\n\n._85e08dU05-w-:hover {\n\tcolor: var(--color-text-action-hover);\n}\n\n.CXh2JiLW-bA- {\n\tdisplay: inline-block;\n\tmargin-left: var(--space-smaller);\n}\n\n.cqNOcJcI-t4- {\n\tcolor: var(--text-color);\n}\n\n.cqNOcJcI-t4-  > :first-child {\n\t\tmargin-top: 0;\n\t}\n\n.cqNOcJcI-t4-  > :last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n._47y2wgbRLp0- {\n\tmargin-top: var(--space-small);\n\tmargin-bottom: var(--space-small);\n}\n\n.Of0KGItgKes- {\n\tmargin-left: var(--space-larger);\n\tmargin-right: var(--space-larger);\n\tmargin-top: var(--space-small);\n\tmargin-bottom: var(--space-small);\n}\n\n.Of0KGItgKes- * {\n\t\tcolor: var(--color-text-secondary);\n\t}\n\n.TtMvIlX8Di4- {\n\twhite-space: pre-wrap;\n}\n\n.mPDKxwFB9Sc- {\n\tmargin-top: var(--space-small);\n\tmargin-bottom: var(--space-small);\n}\n\n.mPDKxwFB9Sc- li {\n\t\tmargin-left: var(--space-larger);\n\t}\n\n/* prominence styles */\n\n.jM1VPFNOiks- {\n\t--text-color: var(--palette-grey-90);\n}\n\n.OLGYppnk-9o- {\n\t--text-color: var(--palette-grey-70);\n}\n\n.ooby-e095NI- {\n\tz-index: var(--elevation-modal);\n\tposition: fixed;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\n\tcolor: var(--color-text-primary);\n\tfont-family: var(--font-family-body);\n}\n\n.eF83HUv91mg- {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\tmax-height: 90vh;\n\toverflow-y: auto;\n\ttranslate: -50% -50%;\n\tborder: solid var(--color-border) var(--space-minuscule);\n\tborder-radius: var(--radius-base);\n\tbackground-color: var(--color-surface);\n\tbox-shadow: var(--shadow-high);\n\tword-wrap: break-word;\n\toverflow-wrap: break-word;\n\ttransition: all var(--timing-base) ease;\n}\n\n.eF83HUv91mg-.qHDJ5Y4MRfw- {\n\tscale: 0.9;\n\topacity: 0;\n}\n\n.eF83HUv91mg-.wImnBWuOaeA- {\n\tscale: 0.8;\n\topacity: 0;\n}\n\n.eF83HUv91mg-.vCfdVw1V6Dk- {\n\twidth: 400px;\n\tmax-width: 70%;\n}\n\n.eF83HUv91mg-._0XmKOJ5hDlk- {\n\twidth: 800px;\n\tmax-width: 80%;\n}\n\n.eF83HUv91mg-.suJn68jKIwk- {\n\twidth: 1200px;\n\tmax-width: 90%;\n}\n\n.eF83HUv91mg-.wNe0eFdKs5E- {\n\ttop: var(--space-extravagant);\n\ttranslate: -50% 0%;\n}\n\n.iCg-JmudeLo- {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tbackground-color: var(--palette-grey-10);\n\topacity: 0.5;\n\topacity: 50%;\n\ttransition: all 0.2s ease;\n}\n\n.iCg-JmudeLo-.qHDJ5Y4MRfw- {\n\topacity: 0;\n}\n\n.iCg-JmudeLo-.wImnBWuOaeA- {\n\topacity: 0;\n}\n\n.wvkeil-1qyM- {\n\tposition: sticky;\n\ttop: 0;\n\tpadding: var(--space-smaller) var(--space-small);\n\tpadding-left: var(--space-large);\n\tbackground-color: inherit;\n}\n\n.wvkeil-1qyM- h2 {\n\tmargin: 0;\n\tfont-weight: var(--font-weight-base);\n\tfont-size: var(--font-size-base);\n\tline-height: var(--element-base);\n}\n\n.-v31HUSIWD4- {\n\tborder-bottom: var(--space-minuscule) solid var(--color-border);\n}\n\n.ow2iCordrK8- {\n\tfont-weight: var(--font-weight-base);\n\tfont-size: var(--font-size-small);\n}\n\n.ow2iCordrK8-.EFHYLg-HiXI- {\n\tmax-height: 90%;\n\tpadding: var(--space-large);\n}\n\n._4gw63G7IYG0- {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: var(--element-base);\n\theight: var(--element-base);\n\tborder: none;\n\tborder-radius: var(--radius-round);\n\tbackground-color: var(--color-surface-interactive-action-secondary-base);\n\tcolor: var(--color-text-interactive-action-secondary-base);\n\ttransition: all 0.2s ease;\n}\n\n._4gw63G7IYG0-:hover {\n\tbackground-color: var(--color-surface-interactive-action-secondary-hover);\n\tcolor: var(--color-text-interactive-action-secondary-hover);\n}\n\n._4gw63G7IYG0-:active {\n\tscale: 0.8;\n\tbackground-color: var(--color-surface-interactive-action-secondary-hover);\n\tcolor: var(--color-text-interactive-action-secondary-hover);\n}\n\n.v1ShS1GPN1A- {\n\tborder: solid var(--color-border) var(--space-minuscule);\n\tborder-radius: var(--radius-base);\n\tbackground-color: var(--color-surface);\n\tbox-shadow: var(--shadow-high);\n}\n\n.v1ShS1GPN1A-.xlCyOAcjM9Y- {\n\tpadding: var(--space-small);\n}\n\n/** The Headless UI portal. Consumes the whole screen. */\n.g-4ozWstdhk- {\n\tz-index: var(--elevation-modal);\n\tposition: fixed;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\n\tcolor: var(--color-text-primary);\n\tfont-family: var(--font-family-body);\n}\n/** The part you interact with. */\n.AF0RCeS7ePI- {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\twidth: 400px;\n\n\tpadding: var(--space-large);\n\ttranslate: -50% -50%;\n\n\tborder: solid var(--color-border) var(--space-minuscule);\n\tborder-radius: var(--radius-base);\n\tbackground-color: var(--color-surface);\n\tword-wrap: break-word;\n\toverflow-wrap: break-word;\n}\n/** The background that greys out the rest of the app. */\n.TbDgSIgs410- {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tbackground-color: var(--palette-grey-10);\n\topacity: 0.5;\n\topacity: 50%;\n}\n.h8Cax1VLlz0- {\n\tbox-sizing: border-box;\n\twidth: 100%;\n\theight: var(--element-base);\n\tpadding-right: var(--space-small);\n\tpadding-left: var(--space-small);\n\n\tborder: 1px solid var(--color-border);\n\tborder-radius: var(--radius-base);\n\n\tbackground-color: var(--color-surface);\n\tcolor: var(--palette-grey-90);\n\tfont-size: var(--font-size-base);\n}\n.h8Cax1VLlz0-:focus {\n\toutline: 2px solid var(--color-border-interactive-action-primary-base);\n}\n._11cB7mSzTWc- {\n\tborder-color: var(--color-surface-interactive-destruction-primary-base);\n}\n._11cB7mSzTWc-:focus {\n\toutline: 2px solid var(--color-border-interactive-destruction-primary-base);\n}\n\n.If-pBdcav0Y- {\n\tdisplay: flex;\n\tposition: relative;\n\talign-items: center;\n\tborder: 1px solid var(--palette-grey-40);\n\tborder-radius: var(--radius-round);\n\tcursor: pointer;\n\ttransition: all 0.2s ease;\n}\n\n.r6-HjHmLouk- {\n\twidth: calc(var(--space-base) * 2);\n\theight: calc(var(--element-small) * 0.8);\n}\n\n.xw55Ll2fwKM- {\n\twidth: calc(var(--space-base) * 4.2);\n\theight: var(--element-base);\n}\n\n.If-pBdcav0Y-:focus {\n\toutline: none;\n\tbox-shadow: 0 0 0 var(--space-smallest) var(--palette-green-70);\n}\n\n.PH0J7clX0bc- {\n\tbackground-color: var(--palette-green-60);\n}\n\n._6monBPL3hwY- {\n\tbackground-color: var(--palette-grey-50);\n}\n\n.e-cSZjkHGw8- {\n\tcursor: not-allowed;\n\topacity: 0.5;\n}\n\n._1tTimr6bxwI- {\n\tdisplay: flex;\n\tposition: absolute;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: var(--radius-round);\n\tbackground-color: var(--palette-white-0);\n\ttransition: transform 0.2s ease;\n}\n\n.r6-HjHmLouk- ._1tTimr6bxwI- {\n\tleft: calc(var(--space-small) * 0.3);\n\twidth: calc(var(--space-base) * 0.8);\n\theight: calc(var(--space-base) * 0.8);\n}\n\n.xw55Ll2fwKM- ._1tTimr6bxwI- {\n\tleft: calc(var(--space-small) * 0.8);\n\twidth: calc(var(--space-base) * 1.8);\n\theight: calc(var(--space-base) * 1.7);\n}\n\n.r6-HjHmLouk-.PH0J7clX0bc- ._1tTimr6bxwI- {\n\ttransform: translateX(calc(var(--space-base) * 0.75));\n}\n\n.xw55Ll2fwKM-.PH0J7clX0bc- ._1tTimr6bxwI- {\n\ttransform: translateX(calc(var(--space-base) * 1.5));\n}\n\n.JS-CLzHa9-I- {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.r6-HjHmLouk- .JS-CLzHa9-I- {\n\twidth: calc(var(--space-base) * 0.6);\n\theight: calc(var(--space-base) * 0.6);\n}\n\n.xw55Ll2fwKM- .JS-CLzHa9-I- {\n\twidth: calc(var(--space-base) * 1.25);\n\theight: calc(var(--space-base) * 1.25);\n}\n\n._6monBPL3hwY- .JS-CLzHa9-I- {\n\tcolor: var(--palette-grey-50);\n}\n\n.PH0J7clX0bc- .JS-CLzHa9-I- {\n\tcolor: var(--palette-green-60);\n}\n\n/* providing text that is only visible to screen readers */\n\n.y97eHHUd5Ns- {\n\tposition: absolute;\n\twidth: var(--space-miniscule);\n\theight: var(--space-miniscule);\n\tmargin: -1px;\n\tpadding: 0;\n\toverflow: hidden;\n\tclip: rect(0, 0, 0, 0);\n\tborder-width: 0;\n\twhite-space: nowrap;\n}\n\n.AS5JrMjrqbQ- {\n\tdisplay: flex;\n\talign-items: center;\n\torder: -1;\n\tcursor: pointer;\n}\n\n.mKZU5aI8-I8- {\n\tdisplay: flex;\n\talign-items: center;\n\torder: 1;\n\tcursor: pointer;\n}\n\n.e-cSZjkHGw8- + .HLUIVXs3n5w- {\n\tcursor: not-allowed;\n\topacity: 0.5;\n}\n\n.YvFE7FqlTS0- {\n\tcolor: var(--color-border-interactive-destruction-primary-hover);\n}\n\n:root {\n\t--tab-inset: var(--space-small);\n}\n\n.cHJe2HsBNic- {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\tmax-height: 100%;\n}\n\n.LfIIg9bwrhQ- {\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\tposition: relative;\n\tmargin-bottom: calc(-1 * var(--space-smallest));\n\toverflow-x: auto;\n\toverflow-y: visible;\n}\n\n.DEdzikxlAkw- {\n\theight: var(--element-small);\n\tmargin: 0;\n\tmargin-top: var(--space-small);\n\tmargin-bottom: var(--space-small);\n\tpadding-right: var(--tab-inset);\n\tpadding-left: var(--tab-inset);\n\tborder: none;\n\tborder-radius: var(--radius-base);\n\toutline: none;\n\tbackground: transparent;\n\tcolor: var(--color-text-tertiary);\n\tcursor: pointer;\n\ttext-wrap: nowrap;\n}\n\n.DEdzikxlAkw-:first-child {\n\tmargin-left: var(--tab-inset);\n}\n\n.DEdzikxlAkw-:last-child {\n\tmargin-right: var(--tab-inset);\n}\n\n.DEdzikxlAkw-.VDB94VYoyB0- {\n\tcolor: var(--color-text-primary);\n}\n\n.DEdzikxlAkw-:hover {\n\tbackground-color: var(--color-surface-interactive-action-tertiary-hover);\n}\n\n._7GjVSlln9Yc- {\n\tdisplay: block;\n\tposition: absolute;\n\tbottom: 0;\n\theight: var(--space-smallest);\n\tbackground-color: var(--color-surface-interactive-action-primary-base);\n\ttransition: all var(--timing-base) ease;\n}\n\n.htdKg6As4bY- {\n\tbox-sizing: border-box;\n\tmax-height: 100%;\n\toverflow-x: hidden;\n\toverflow-y: \"auto\";\n}\n\n.htdKg6As4bY-.HeJcnz8heHk- {\n\tpadding: var(--space-base);\n}\n\n.eQt1Jis30lo- {\n\tposition: relative;\n\tborder-bottom: solid var(--space-smallest) var(--color-border);\n}\n\n._6Vf7pQfyKKk-:after,\n.jyevrJK7Bcg-:before {\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\twidth: 24px;\n\tcontent: \"\";\n}\n\n._6Vf7pQfyKKk-:after {\n\tright: 0;\n\tbox-shadow: inset -16px 0 16px -16px\n\t\tvar(--color-border-interactive-action-secondary-base);\n}\n\n.jyevrJK7Bcg-:before {\n\tleft: 0;\n\tbox-shadow: inset 16px 0 16px -16px var(--color-border-interactive-action-secondary-base);\n}\n\n.feBFPyem0vg- {\n\tdisplay: inline-flex;\n}\n\n._5-yE5oWUWPs- {\n\tz-index: var(--elevation-tooltip);\n}\n\n._-1XZXRLzwUw- {\n\tpadding: var(--space-smaller) var(--space-small);\n\tborder-radius: var(--radius-base);\n\tbackground-color: var(--color-surface-secondary);\n\tfill: var(--color-surface-secondary);\n\tbox-shadow: var(--shadow-base);\n}\n\n/* TODO: Find a way to include this at the rollup stage. */\n/* This would be a bit better but storybook needs the relative import. */\n/* @import \"@samdesk/design/src/screen.css\"; */\n@custom-media --viewport-mobile (max-width: 600px);\n@custom-media --viewport-desktop (min-width: 600.02px);\n.WJVsKqsNsx4- {\n\tdisplay: flex;\n\tmax-width: 100%;\n\tgap: var(--stack-gap);\n}\n@media (max-width: 600px) {\n\t.dISGEb-XpGg- {\n\t\tflex-direction: column;\n\t}\n}\n@media (--viewport-mobile) {\n\t.dISGEb-XpGg- {\n\t\tflex-direction: column;\n\t}\n}\n@media (min-width: 600.02px) {\n\t.EJSTIQ4PYVU- {\n\t\tflex-direction: column;\n\t}\n}\n@media (--viewport-desktop) {\n\t.EJSTIQ4PYVU- {\n\t\tflex-direction: column;\n\t}\n}\n.-MH92ccOyS0- {\n\tjustify-content: flex-start;\n}\n.fS--JKd4uSo- {\n\tjustify-content: center;\n}\n.hpG5Y-ugcqs- {\n\tjustify-content: flex-end;\n}\n._2NLuWqLYdmE- {\n\tjustify-content: stretch;\n}\n._2NLuWqLYdmE-  > * {\n\t\tflex: 1;\n\t}\n.DOfoTDkuOzQ- {\n\tjustify-content: space-between;\n}\n.wC9U2et5jXM- {\n\talign-items: flex-start;\n}\n.-lKy-oIjfG0- {\n\talign-items: center;\n}\n.wE6pa1lL70M- {\n\talign-items: flex-end;\n}\n.ard80dLr6aw- {\n\talign-items: stretch;\n}\n.kVKMsZ5xY9Q- {\n\t--stack-gap: 0;\n}\n.NpH57aGewlA- {\n\t--stack-gap: var(--space-smaller);\n}\n.hdixyL4lGBA- {\n\t--stack-gap: var(--space-small);\n}\n.eajX3-2t-0A- {\n\t--stack-gap: var(--space-base);\n}\n.J79pzGu9ZD8- {\n\t--stack-gap: var(--space-large);\n}\n.vZDDhzbRF6U- {\n\t--stack-gap: var(--space-larger);\n}\n._6StuIuIA76A- {\n\tflex-wrap: wrap;\n}\n.UJlW0e-gocc- {\n\tflex-wrap: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
